import { FICTION_DISCLAIMER_SHORT } from "./disclaimerCopy";

/**
 * Compact firstbid-style footer: made-by X · Privacy Policy · Contact email.
 * Full Pricing / Fiction / Terms / Refund / Contact copy lives on #/legal/privacy
 * (and the old #/legal/:slug routes still work).
 */
function goLegalPrivacy(e) {
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
  e.preventDefault();
  const next = "#/legal/privacy";
  if (window.location.hash !== next) window.location.hash = next;
  window.dispatchEvent(
    typeof HashChangeEvent === "function"
      ? new HashChangeEvent("hashchange")
      : new Event("hashchange")
  );
}

export function Footer() {
  return (
    <footer className="border-t border-[#141d34] py-8 text-center">
      <p className="mono text-xs text-slate-500">
        <span className="text-gmh-orange">getmehome.lol</span> — Every dollar is fuel. Every bid is hope.
      </p>
      <p
        data-testid="fiction-disclaimer"
        className="mono mx-auto mt-3 max-w-2xl px-4 text-[10px] leading-relaxed text-slate-600"
      >
        {FICTION_DISCLAIMER_SHORT}
      </p>
      <nav
        data-testid="legal-footer-nav"
        className="mono mt-4 flex flex-wrap items-center justify-center gap-x-2 gap-y-2 px-4 text-[11px] tracking-wide text-slate-500"
      >
        <span>
          made by{" "}
          <a
            data-testid="footer-made-by-x"
            href="https://x.com/singlesouup"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-gmh-cyan"
          >
            @singlesouup
          </a>
        </span>
        <span aria-hidden="true" className="text-slate-600">
          ·
        </span>
        <a
          href="#/legal/privacy"
          data-testid="footer-link-privacy"
          className="underline hover:text-gmh-cyan"
          onClick={goLegalPrivacy}
        >
          Privacy Policy
        </a>
        <span aria-hidden="true" className="text-slate-600">
          ·
        </span>
        <span>
          Contact:{" "}
          <a
            data-testid="footer-contact-email"
            href="mailto:getmehome.support@gmail.com"
            className="underline hover:text-gmh-cyan"
          >
            getmehome.support@gmail.com
          </a>
        </span>
      </nav>
      <p
        data-testid="footer-expedition-note"
        className="mono mx-auto mt-3 max-w-2xl px-4 text-[10px] leading-relaxed text-slate-600"
      >
        Expedition 1 — 60 days of rations. If the window ends without $10k, the beacon goes dark; a
        later expedition can start. $10k is the only win. Listings are paid placement, not a rescue.
      </p>
      <p className="mono mx-auto mt-2 max-w-2xl px-4 text-[10px] leading-relaxed text-slate-600">
        Special thanks to{" "}
        <a
          data-testid="footer-thanks-uday"
          href="https://www.instagram.com/uday_vinayak_goswami/"
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-gmh-cyan"
        >
          @uday_vinayak_goswami
        </a>
      </p>
    </footer>
  );
}

export default Footer;
